import { NgModule } from "@angular/core";
import { DasboardRoutingModule } from "./dashboard-routing.module";
import { DashboardComponent } from "./dashboard.component";
import {
  NbLayoutModule,
  NbSidebarService,
  NbSidebarModule,
  NbIconModule,
  NbActionsModule,
  NbContextMenuModule,
  NbUserModule,
  NbMenuModule,
  NbButtonModule,
  NbCardModule,
  NbInputModule,
  NbRadioModule,
  NbSelectModule,
  NbAlertModule,
  NbSpinnerModule,
  NbCheckboxModule,
  NbToggleModule,
  NbWindowModule,
  NbTabsetModule,
  NbCalendarRangeModule,
} from "@nebular/theme";
import { ProfileComponent } from "./pages/profile/profile.component";
import { SettingsComponent } from "./pages/profile/settings/settings.component";
import { IndexComponent } from "./pages/index/index.component";
import { LogoutComponent } from "./pages/logout/logout.component";
import { JwtHelperService } from "@auth0/angular-jwt";
import { InvalidAuthComponent } from "./pages/invalid-auth/invalid-auth.component";
import { DashboardPageNotFoundComponent } from "./pages/dashboard-page-not-found/dashboard-page-not-found.component";
import { UserProfileComponent } from "./pages/profile/user-profile/user-profile.component";
import { CommonModule } from "@angular/common";
import { ChangePasswordComponent } from "./pages/profile/change-password/change-password.component";
import { DocumentVerificationComponent } from "./pages/profile/document-verification/document-verification.component";
import { NotificationSettingsComponent } from "./pages/profile/notification-settings/notification-settings.component";
import { AccountSecurityComponent } from "./pages/profile/account-security/account-security.component";
import { TradeExperienceComponent } from "./pages/profile/trade-experience/trade-experience.component";
import { AccountVerificationComponent } from "./pages/profile/account-verification/account-verification.component";
import { ReactiveFormsModule } from "@angular/forms";
import { AccountsComponent } from "./pages/accounts/accounts.component";
import { DemoComponent } from "./pages/accounts/demo/demo.component";
import { LiveComponent } from "./pages/accounts/live/live.component";
import { FinanceComponent } from "./pages/finance/finance.component";
import { DepositComponent } from "./pages/finance/deposit/deposit.component";
import { WithdrawComponent } from "./pages/finance/withdraw/withdraw.component";
import { InternalTransferComponent } from "./pages/finance/internal-transfer/internal-transfer.component";
import { PlatformComponent } from "./pages/platform/platform.component";
import { ToolsComponent } from "./pages/tools/tools.component";
import { EconomicCalendarComponent } from "./pages/tools/economic-calendar/economic-calendar.component";
import { ReportComponent } from "./pages/finance/report/report.component";
import { DepositReportComponent } from './pages/finance/report/deposit-report/deposit-report.component';
import { WithdrawReportComponent } from './pages/finance/report/withdraw-report/withdraw-report.component';
import { InternalTransferReportComponent } from './pages/finance/report/internal-transfer-report/internal-transfer-report.component';
import { UserBankAccountComponent } from './pages/profile/user-bank-account/user-bank-account.component';

@NgModule({
  declarations: [
    DashboardComponent,
    ProfileComponent,
    SettingsComponent,
    IndexComponent,
    LogoutComponent,
    InvalidAuthComponent,
    DashboardPageNotFoundComponent,
    UserProfileComponent,
    ChangePasswordComponent,
    DocumentVerificationComponent,
    NotificationSettingsComponent,
    AccountSecurityComponent,
    TradeExperienceComponent,
    AccountVerificationComponent,
    AccountsComponent,
    DemoComponent,
    LiveComponent,
    FinanceComponent,
    DepositComponent,
    WithdrawComponent,
    InternalTransferComponent,
    PlatformComponent,
    ToolsComponent,
    EconomicCalendarComponent,
    ReportComponent,
    DepositReportComponent,
    WithdrawReportComponent,
    InternalTransferReportComponent,
    UserBankAccountComponent,
  ],
  imports: [
    DasboardRoutingModule,
    NbLayoutModule,
    NbSidebarModule.forRoot(),
    NbIconModule,
    NbActionsModule,
    NbContextMenuModule,
    NbUserModule,
    NbMenuModule,
    NbButtonModule,
    NbCardModule,
    NbInputModule,
    NbRadioModule,
    NbSelectModule,
    NbAlertModule,
    NbTabsetModule,
    ReactiveFormsModule,
    CommonModule,
    NbSpinnerModule,
    NbCheckboxModule,
    NbToggleModule,
    NbWindowModule.forRoot(),
    NbCalendarRangeModule,
  ],
  exports: [],
  providers: [NbSidebarService, JwtHelperService],
})
export class DashboardModule {}
